import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Hidden,
  IconButton,
  Modal,
  Typography,
} from "@material-ui/core";
import TitleContainer from "../../LogoLinks/TitleContainer";
import LayoutContainer from "../../../components/LayoutsContainer";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { ArrowLeft, ArrowRight, Close } from "@material-ui/icons";
import { getImageUrl } from "../../../redux/types";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: "5vh 0vw",
    [theme.breakpoints.down("md")]: {
      padding: "1vh 0vw",
    },
  },
  aboutUsImage: {
    height: "50vh",
    width: "100%",
    objectFit: "contain",
  },
  TitleContainer: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(0),
    },
  },
  peopleContainer: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(1),
    },
  },
  modalRoot: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalCard: {
    width: "60vw",
    outline: "none",
    // display: "flex",
    // flexDirection: "column",
    // alignItems: "center",
    // justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      width: "90vw",
      maxHeight: "90vh",
      outline: "none",
    },
  },
  modalImage: {
    width: "100%",
    maxHeight: "60vh",
    objectFit: "contain",
    alignSelf: "center",
    justifySelf: "center",
    pointerEvents: "none",
  },
  emptydiv: {
    minHeight: "50vh",
    maxHeight: "60vh",
    [theme.breakpoints.down("md")]: {
      height: "50vh",
      // maxHeight: "60vh",
    },
  },
  arrowIcons: {
    border: "2px solid #ddd",
    borderRadius: 100,
    // padding: theme.spacing(2),
    fontSize: "2rem",
  },
  imageCardContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    color: theme.palette.primary.main,
    fontSize: "2rem",
  },
  gridImage: {
    width: "100%",
    display: "block",
    padding: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(1),
    },
  },
}));

const AboutUsLayout = ({ data }) => {
  const [open, setOpen] = React.useState();
  const [activeOpen, setActiveOpen] = React.useState(false);
  const classes = useStyles();

  const ImageModal = () => {
    return (
      <Modal open={activeOpen} className={classes.modalRoot}>
        <Card className={classes.modalCard}>
          <CardHeader
            title={<Typography variant="h6">{data.title}</Typography>}
            action={
              <IconButton
                onClick={() => {
                  setOpen();
                  setActiveOpen(false);
                }}
              >
                <Close />
              </IconButton>
            }
          />
          <Divider />

          <CardContent className={classes.imageCardContent}>
            <Grid container>
              <Hidden mdDown>
                <Grid
                  item
                  lg={1}
                  container
                  justify="center"
                  alignItems="center"
                >
                  <IconButton
                    className={classes.arrowIcons}
                    onClick={() => {
                      if (open > 0) {
                        setOpen(open - 1);
                      }
                    }}
                  >
                    <ArrowLeft className={classes.icon} />
                  </IconButton>
                </Grid>
              </Hidden>

              <Grid item lg={10} md={10} sm={12} xs={12}>
                {data?.data[open]?.imageSrc ? (
                  <img
                    loading="eager"
                    src={getImageUrl(data?.data[open].imageSrc)}
                    className={classes.modalImage}
                  />
                ) : (
                  <div className={classes.emptydiv} />
                )}
              </Grid>
              <Hidden mdDown>
                <Grid
                  item
                  lg={1}
                  container
                  justify="center"
                  alignItems="center"
                >
                  <IconButton
                    className={classes.arrowIcons}
                    onClick={() => {
                      if (open < data?.data?.length - 1) {
                        setOpen(open + 1);
                      }
                    }}
                  >
                    <ArrowRight className={classes.icon} />
                  </IconButton>
                </Grid>
              </Hidden>
              <Hidden smUp>
                <Grid item sm={12} xs={12} container justify="space-between">
                  <Grid item>
                    <IconButton
                      className={classes.arrowIcons}
                      onClick={() => {
                        if (open > 0) {
                          setOpen(open - 1);
                        }
                      }}
                    >
                      <ArrowLeft className={classes.icon} />
                    </IconButton>
                  </Grid>

                  <Grid item>
                    <IconButton
                      className={classes.arrowIcons}
                      onClick={() => {
                        if (open < data?.data?.length - 1) {
                          setOpen(open + 1);
                        }
                      }}
                    >
                      <ArrowRight className={classes.icon} />
                    </IconButton>
                  </Grid>
                </Grid>
              </Hidden>
            </Grid>
          </CardContent>
        </Card>
      </Modal>
    );
  };
  return (
    <div className={classes.root}>
      <LayoutContainer>
        <ImageModal />
        <Grid container spacing={2}>
          <Grid item className={classes.TitleContainer}>
            <TitleContainer title={data.title} />
          </Grid>
        </Grid>
        <ResponsiveMasonry columnsCountBreakPoints={{ 350: 2, 750: 2, 900: 3 }}>
          <Masonry>
            {data?.data?.map((tile, index) => {
              return (
                <div
                  onClick={(e) => {
                    if (!activeOpen) {
                      setActiveOpen(true);
                    }
                    setOpen(index);
                  }}
                >
                  <img
                    src={getImageUrl(tile.imageSrc)}
                    alt={tile.id}
                    className={classes.gridImage}
                  />
                </div>
              );
            })}
          </Masonry>
        </ResponsiveMasonry>
      </LayoutContainer>
    </div>
  );
};
export default AboutUsLayout;

// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import LayoutContainer from "../../../components/LayoutsContainer";
// import { AccordionActions, Button, Grid } from "@material-ui/core";
// import TitleContainer from "../../LogoLinks/TitleContainer";
// import PageTitle from "../../../components/Common/PagesTitle";
// import { useHistory } from "react-router-dom";

// import GridList from "@material-ui/core/GridList";
// import GridListTile from "@material-ui/core/GridListTile";

// import UseMobile from "../../../hooks/useIsMobile";

// // import tileData from './tileData';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     padding: "5vh 0vw",
//     [theme.breakpoints.down("md")]: {
//       padding: "2vh 0vw",
//     },
//   },
//   achievementContainer: {
//     marginTop: theme.spacing(5),
//     [theme.breakpoints.down("md")]: {
//       marginTop: theme.spacing(3),
//     },
//   },

//   readmoreBtn: {
//     borderRadius: 100,
//   },
//   gridList: {
//     width: "100%",
//     height: "100vh",
//     marginTop: theme.spacing(2),
//   },
// }));

// const GramSchemesLayout = ({ data }) => {
//   const classes = useStyles();
//   const history = useHistory();
//   const [imageData, setImageData] = React.useState([]);
//   const handleNavigate = (link, extenral) => {
//     if (extenral) {
//       return window.open(link, "_blank");
//     }
//     history.push(link);
//   };

//   async function handleGetData() {
//     await fetch(
//       "https://pixabay.com/?key=10842679-b2a2219e300eb318613b5a01f&q=indian+village&image_type=photo"
//     )
//       .then((res) => res.json())
//       .then((res) => {
//         setImageData(res.hits);
//       });
//   }

//   React.useEffect(() => {
//     if (data?.data.length > 0) {
//       setImageData(data?.data);
//     } else {
//       handleGetData();
//     }
//   }, [data?.data]);
//   const isMobile = UseMobile();

//   console.log("galeri data", data);
//   return (
//     <div className={classes.root}>
//       <LayoutContainer>
//         <div>
//           <Grid
//             container
//             direction="column"
//             alignItems={isMobile ? "center" : "flex-start"}
//           >
//             <Grid item className={classes.TitleContainer}>
//               <PageTitle title={data.title} />
//             </Grid>
//           </Grid>
//         </div>
//         <div className={classes.achievementContainer}>
//           <GridList
//             cellHeight={!isMobile ? 300 : 150}
//             className={classes.gridList}
//             cols={!isMobile ? 3 : 2}
//           >
//             {data?.data.map((tile, index) => (
//               <GridListTile key={index} cols={tile?.cols || 1}>
//                 <img src={tile.imageSrc} alt={tile.id} />
//               </GridListTile>
//             ))}
//           </GridList>
//         </div>
//         {/* <div className={classes.achievementContainer}>
//           {imageData.map((acc, index) => {
//             return <div>{acc.id}</div>;
//           })}
//         </div> */}
//       </LayoutContainer>
//     </div>
//   );
// };
// export default GramSchemesLayout;
